
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contributors/[slug]",
      function () {
        return require("private-next-pages/contributors/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contributors/[slug]"])
      });
    }
  